module.exports = __webpack_public_path__ + "static/anders-f3b443d9d1bb42bd4731cf5ae8f2e644.svg";